import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/vue-query';
import { minutesToMilliseconds } from 'date-fns';
import type { MaybeRefOrGetter } from '@vueuse/core';

import { fetchAgreements } from '../services/agreement';

export const agreementQueryKeys = createQueryKeys('agreement', {
  index: (requirementKey: MaybeRefOrGetter<string>, documentKey: MaybeRefOrGetter<string>) => [{ requirementKey, documentKey }],
});

export function useFetchAgreementList(signatureRequestKey: MaybeRefOrGetter<string>, documentKey: MaybeRefOrGetter<string>) {
  const result = useQuery({
    queryKey: agreementQueryKeys.index(signatureRequestKey, documentKey).queryKey,
    queryFn: () => fetchAgreements(toValue(signatureRequestKey), toValue(documentKey)),
    staleTime: minutesToMilliseconds(3),
    initialDataUpdatedAt: 0,
    initialData: [],
  });

  return {
    ...result,
    agreements: result.data,
  };
}
